import axios from "../context/axiosConfig";
import { useState, useEffect } from "react";

export default function IrrigationMaintenance({
  onBack,
  onSelect,
  selected_plant_id,
}) {
  const [giftEc, setGiftEc] = useState("");
  const [nutrient_recipe, setNutrientRecipe] = useState("");
  const [giftPh, setGiftPh] = useState("");
  const [shotSize, setShotSize] = useState("");
  const [shotFrequency, setShotFrequency] = useState("");
  const [waterTemp, setWaterTemp] = useState("");
  const [drainVolume, setDrainVolume] = useState("");
  const [drainEc, setDrainEc] = useState("");
  const [drainPh, setDrainPh] = useState("");
  const [substrateEc, setSubstrateEc] = useState("");
  const [substratePh, setSubstratePh] = useState("");
  const [substrateTemp, setSubstrateTemp] = useState("");
  const [waterContent, setWaterContent] = useState("");
  const [plantCount, setPlantCount] = useState(0);
  const [selectedOption, setSelectedOption] = useState("");
  const [ecLevel, setEcLevel] = useState("");
  const [phLevel, setPhLevel] = useState("");
  const [runoffEc, setRunoffEc] = useState("");
  const [runoffPh, setRunoffPh] = useState("");
  const [volume, setVolume] = useState("");
  const [nutrientRecipes, setNutrientRecipes] = useState([]);
  const [loading, setLoading] = useState(true);

  // Check if we have multiple plants (from a plot)
  useEffect(() => {
    if (Array.isArray(selected_plant_id)) {
      setPlantCount(selected_plant_id.length);
      console.log(`Found ${selected_plant_id.length} plants for irrigation maintenance`);
    }
  }, [selected_plant_id]);

  /* local state that tracks which dropdowns are open ----------------- */
  const [openSubs, setOpenSubs] = useState(new Set());
  const toggle = (key) =>
    setOpenSubs((prev) => {
      const next = new Set(prev);
      next.has(key) ? next.delete(key) : next.add(key);
      return next;
    });

  const org_id = localStorage.getItem("organization");
  
  // Fetch nutrient recipes from lookup API
  useEffect(() => {
    const fetchNutrientRecipes = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `/orgs/${org_id}/lookups/nutrient_recipe?locale=en`,
          { withCredentials: true }
        );
        setNutrientRecipes(response.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching nutrient recipes:", err);
        setLoading(false);
      }
    };
    
    fetchNutrientRecipes();
  }, [org_id]);

  const handleUpload = async () => {
    console.log('Selected plant ID:', selected_plant_id);
    try {
        // Create array of plant IDs
        const plantIds = Array.isArray(selected_plant_id) ? selected_plant_id : [selected_plant_id];
        
        // Build request payload for each opened irrigation type
        const requests = [];
        
        // Check if Gift section is open and has data
        if (openSubs.has("Gift") && (giftPh || giftEc || shotSize || shotFrequency || waterTemp || nutrient_recipe)) {
            const giftRequest = {
                irrigation_type: "gift",
                plant_id: plantIds,
                nutrient_recipe_id: parseInt(nutrient_recipe) || null,
                ph: giftPh ? parseFloat(giftPh) : null,
                ec: giftEc ? parseFloat(giftEc) : null,
                shot_size: shotSize ? parseInt(shotSize) : null,
                shot_frequency: shotFrequency ? parseInt(shotFrequency) : null,
                water_temp: waterTemp ? parseFloat(waterTemp) : null
            };
            requests.push(giftRequest);
        }
        
        // Check if Drain section is open and has data
        if (openSubs.has("Drain") && (drainVolume || drainPh || drainEc)) {
            const drainRequest = {
                irrigation_type: "drain",
                plant_id: plantIds,
                drain_volume: drainVolume ? parseInt(drainVolume) : null,
                ph: drainPh ? parseFloat(drainPh) : null,
                ec: drainEc ? parseFloat(drainEc) : null
            };
            requests.push(drainRequest);
        }
        
        // Check if Substrate section is open and has data
        if (openSubs.has("Substrate") && (waterContent || substratePh || substrateEc || substrateTemp)) {
            const substrateRequest = {
                irrigation_type: "substrate",
                plant_id: plantIds,
                water_content: waterContent ? parseFloat(waterContent) : null,
                ph: substratePh ? parseFloat(substratePh) : null,
                ec: substrateEc ? parseFloat(substrateEc) : null,
                substrate_temp: substrateTemp ? parseFloat(substrateTemp) : null
            };
            requests.push(substrateRequest);
        }
        
        // Ensure at least one request is being sent
        if (requests.length === 0) {
            alert("Please fill out at least one irrigation section");
            return;
        }
        
        // Send all requests in a single API call
        await axios.post(
            `/orgs/${org_id}/maintenance/irrigation`,
            requests,
            {
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
        alert('Upload complete');
        onBack && onBack(); // Return to previous screen after successful upload
    } catch (err) {
        console.error('Upload failed:', err);
        if (err.response?.status === 400) {
                alert('Upload failed - Check if all required fields are filled in correctly');
            } else if (err.response?.status === 401 || err.response?.status === 403) {
                alert("Upload failed - You are no longer logged in or you don't have access to this resource");
            } else if (err.response?.status === 500) {
                alert("Upload failed - Something went wrong in the service, please try again later");
            } else {
                alert(`Upload failed with error: ${err.response}`);
            }
    }
  };

  /* ------------------------------------------------------------------ */
  return (
    <>
      {/* header & back -------------------------------------------------- */}
      <div className="maintenanceHeader">
        <h3>Irrigation</h3>
        <button className="uploadMaintenanceBtn" onClick={handleUpload}>
          Upload
        </button>
      </div>

      <div className="maintenaceGrid maintenanceList">
        <div className="dropdownBlock">
          <div className="purpleBtn extraGridBtn blueBtn" onClick={onBack}>
            Back
          </div>
        </div>

        {plantCount > 1 && (
          <div className="plotMaintenanceNotice">
            Applying irrigation maintenance to all plants in plot ({plantCount} plants)
          </div>
        )}

        {/* ---------- Gift -------------------------------------------- */}
        <div className="dropdownBlock">
          <div
            className="purpleBtn extraGridBtn"
            onClick={() => toggle("Gift")}
          >
            Gift {openSubs.has("Gift") ? "▲" : "▼"}
          </div>
          {openSubs.has("Gift") && (
            <div className="dropdownInner">
              <table className="maintenanceTable">
                <tbody>
                  <tr>
                    <td>Nutrient Recipe</td>
                    <td>
                      {loading ? (
                        <div>Loading recipes...</div>
                      ) : (
                        <select
                          value={nutrient_recipe}
                          className="newMaintenanceInput"
                          onChange={(e) => setNutrientRecipe(e.target.value)}
                        >
                          <option value="">Select Recipe</option>
                          {nutrientRecipes.map((recipe) => (
                            <option key={recipe.id} value={recipe.id.toString()}>
                              {recipe.name}
                            </option>
                          ))}
                        </select>
                      )}
                    </td>
                  </tr>
                  {[
                    {
                      field: "ph",
                      setState: setGiftPh,
                      value: giftPh,
                      unit: "",
                    },
                    {
                      field: "ec",
                      setState: setGiftEc,
                      value: giftEc,
                      unit: "mS/cm",
                    },
                    {
                      field: "Shot Size",
                      setState: setShotSize,
                      value: shotSize,
                      unit: "mL",
                    },
                    {
                      field: "Shot Frequency",
                      setState: setShotFrequency,
                      value: shotFrequency,
                      unit: "Shots/day",
                    },
                    {
                      field: "Water Temperature",
                      setState: setWaterTemp,
                      value: waterTemp,
                      unit: "°C",
                    },
                  ].map(({ field, setState, value, unit }) => (
                    <tr key={field}>
                      <td>{field}</td>
                      <td style={{ position: "relative" }}>
                        <input
                          className="newMaintenanceInput"
                          type="text"
                          value={value}
                          onKeyPress={(e) => {
                            const isNumber = /[0-9]/.test(e.key);
                            const isDot = e.key === ".";
                            const hasDot = e.target.value.includes(".");
                            if ((!isNumber && !isDot) || (isDot && hasDot)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "" || /^\d*\.?\d*$/.test(value)) {
                              if (
                                (field === "Shot Size" ||
                                  field === "Shot Frequency") &&
                                value.includes(".")
                              ) {
                                return;
                              }
                              if (
                                field === "Water Temperature" &&
                                value.includes(".") &&
                                value.split(".")[1].length > 1
                              ) {
                                return;
                              }
                                if (field === "ph" && value !== "") {
                                  const phValue = parseFloat(value);
                                  if (phValue > 14 || phValue < 0) {
                                    alert("pH values should be between 0 and 14");
                                  }
                                }
                                if (
                                (field === "ph" || field === "ec") &&
                                value.includes(".") &&
                                value.split(".")[1].length > 2
                                ) {
                                return;
                              }
                              setState(value);
                            }
                          }}
                        />
                        {unit && (
                          <span
                            style={{
                              position: "absolute",
                              right: "10.5vw",
                              top: "50%",
                              transform: "translateY(-50%)",
                              color: "#666",
                            }}
                            className="tableText"
                          >
                            {unit}
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button
                type="button"
                className="clear-selection"
                onClick={() => {
                  setGiftPh("");
                  setGiftEc("");
                  setShotSize("");
                  setShotFrequency("");
                  setWaterTemp("");
                  setNutrientRecipe("");
                }}
              >
                Clear
              </button>
            </div>
          )}
        </div>

        {/* ---------- Drain -------------------------------------------- */}
        <div className="dropdownBlock">
          <div
            className="purpleBtn extraGridBtn"
            onClick={() => toggle("Drain")}
          >
            Drain {openSubs.has("Drain") ? "▲" : "▼"}
          </div>
          {openSubs.has("Drain") && (
            <div className="dropdownInner">
              <table className="maintenanceTable">
                <tbody>
                  {[
                    {
                      field: "Drain Volume",
                      setState: setDrainVolume,
                      unit: "mL",
                    },
                    { field: "ph", setState: setDrainPh, unit: "" },
                    { field: "ec", setState: setDrainEc, unit: "mS/cm" },
                  ].map(({ field, setState, unit }) => (
                    <tr key={field}>
                      <td>{field}</td>
                      <td style={{ position: "relative" }}>
                        <input
                          className="newMaintenanceInput"
                          type="text"
                          value={
                            field === "Drain Volume"
                              ? drainVolume
                              : field === "ph"
                              ? drainPh
                              : field === "ec"
                              ? drainEc
                              : ""
                          }
                          onKeyPress={(e) => {
                            const isNumber = /[0-9]/.test(e.key);
                            const isDot = e.key === ".";
                            const hasDot = e.target.value.includes(".");
                            if ((!isNumber && !isDot) || (isDot && hasDot)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "" || /^\d*\.?\d*$/.test(value)) {
                              if (
                                field === "Drain Volume" &&
                                value.includes(".")
                              ) {
                                return;
                              }
                              if (field === "ph" && value !== "") {
                                  const phValue = parseFloat(value);
                                  if (phValue > 14 || phValue < 0) {
                                    alert("pH values should be between 0 and 14");
                                  }
                                }
                                if (
                                (field === "ph" || field === "ec") &&
                                value.includes(".") &&
                                value.split(".")[1].length > 2
                                ) {
                                return;
                              }
                              setState(value);
                            }
                          }}
                        />
                        {unit && (
                          <span
                            style={{
                              position: "absolute",
                              right: "11vw",
                              top: "50%",
                              transform: "translateY(-50%)",
                              color: "#666",
                            }}
                            className="tableText"
                          >
                            {unit}
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button
                type="button"
                className="clear-selection"
                onClick={() => {
                  setDrainVolume("");
                  setDrainPh("");
                  setDrainEc("");
                }}
              >
                Clear
              </button>
            </div>
          )}
        </div>

        {/* ---------- Substrate -------------------------------------------- */}
        <div className="dropdownBlock">
          <div
            className="purpleBtn extraGridBtn"
            onClick={() => toggle("Substrate")}
          >
            Substrate {openSubs.has("Substrate") ? "▲" : "▼"}
          </div>
          {openSubs.has("Substrate") && (
            <div className="dropdownInner">
              <table className="maintenanceTable">
                <tbody>
                  {[
                    {
                      field: "Water Content",
                      setState: setWaterContent,
                      value: waterContent,
                      unit: "%",
                    },
                    {
                      field: "ph",
                      setState: setSubstratePh,
                      value: substratePh,
                      unit: "",
                    },
                    {
                      field: "ec",
                      setState: setSubstrateEc,
                      value: substrateEc,
                      unit: "mS/cm",
                    },
                    {
                      field: "Substrate Temperature",
                      setState: setSubstrateTemp,
                      value: substrateTemp,
                      unit: "°C",
                    },
                  ].map(({ field, setState, value, unit }) => (
                    <tr key={field}>
                      <td>{field}</td>
                      <td style={{ position: "relative" }}>
                        <input
                          className="newMaintenanceInput"
                          type="text"
                          value={value}
                          onKeyPress={(e) => {
                            const isNumber = /[0-9]/.test(e.key);
                            const isDot = e.key === ".";
                            const hasDot = e.target.value.includes(".");
                            if ((!isNumber && !isDot) || (isDot && hasDot)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "" || /^\d*\.?\d*$/.test(value)) {
                              if (
                                (field === "Water Content" ||
                                  field === "Substrate Temperature") &&
                                value.includes(".") &&
                                value.split(".")[1].length > 1
                              ) {
                                return;
                              }
                              if (field === "ph" && value !== "") {
                                  const phValue = parseFloat(value);
                                  if (phValue > 14 || phValue < 0) {
                                    alert("pH values should be between 0 and 14");
                                  }
                                }
                                if (
                                (field === "ph" || field === "ec") &&
                                value.includes(".") &&
                                value.split(".")[1].length > 2
                                ) {
                                return;
                              }
                              setState(value);
                            }
                          }}
                        />
                        {unit && (
                          <span
                            style={{
                              position: "absolute",
                              right: "10.5vw",
                              top: "50%",
                              transform: "translateY(-50%)",
                              color: "#666",
                            }}
                          >
                            {unit}
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button
                type="button"
                className="clear-selection"
                onClick={() => {
                  setWaterContent("");
                  setSubstratePh("");
                  setSubstrateEc("");
                  setSubstrateTemp("");
                }}
              >
                Clear
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
